import { Inject, Injectable } from '@angular/core';
import { ParameterResolutionService } from '@app/core/services/parameter/parameter.service';
import { ProfileService } from '@app/core/services/profile/profile.service';
import { FieldType } from '@app/shared/constants';
import { RSQLOperator } from '@app/shared/models/rsql/rsql.operators';
import { DataSource } from '@components/data/data-table-new/datasource/datasource.component';
import { MultiselectStatus } from '@components/data/data-table-new/directives/datatable-multiselect.directive';
import { SearchFilter } from '@components/data/data-table-new/directives/datatable-search.directive';
import { EntitySelectionModel } from '@components/data/data-table-new/entitySelectionModel';
import { DataTableState } from '@components/data/data-table-new/state/state.model';
import { StateService } from '@components/data/data-table-new/state/state.service';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { Notification } from '../../model/notification.model';

@Injectable()
export class NotificationViewerTableData {
  stateId = 'notificationState';
  datasource = new DataSource<Notification>();
  selection = new EntitySelectionModel<Notification>(true, []);
  multiselectStatus: MultiselectStatus = { active: false };
  stateSubject$ = new Subject<DataTableState>();
  displayedColumns: string[] = [];
  searchFilters: SearchFilter[] = [];

  constructor(
    protected profileService: ProfileService,
    protected translateService: TranslateService,
    @Inject('StateService') protected stateService: StateService,
    protected parameterResolutionService: ParameterResolutionService
  ) {
    this.searchFilters = this.getSearchFilters();
  }

  protected getSearchFilters(): SearchFilter[] {
    return [];
  }

  getState(): DataTableState {
    const state: DataTableState = this.stateService.get(this.stateId);
    if (Object.keys(state.filter.value).length === 0) {
      state.filter.value = {
        error: {
          key: 'category',
          operator: RSQLOperator.EQUAL,
          value: 'ERROR',
          valueType: FieldType.STRING
        },
        flagged: {
          key: 'category',
          operator: RSQLOperator.EQUAL,
          value: 'FLAGGED',
          valueType: FieldType.STRING
        },
        important: {
          key: 'notificationUsers.important',
          operator: RSQLOperator.EQUAL,
          value: true,
          valueType: FieldType.BOOLEAN
        },
        unread: {
          key: 'notificationUsers.unread',
          operator: RSQLOperator.EQUAL,
          value: true,
          valueType: FieldType.BOOLEAN
        }
      };
    }
    state.page.size = this.parameterResolutionService.resolveNumericValue('NOT_USER_PAGINATION');
    state.sort.column = 'creationDate';
    state.sort.direction = 'desc';
    return state;
  }

  clear() {
    this.datasource.data = [];
    this.multiselectStatus.active = false;
    this.selection.clear();
  }
}
